export const KEY_STATUS = {
    DRAFT: 0,
    PUBLISHED: 1,
    DELETED: 2
}